export const APP_ID = process.env.APPID
export const SUB_APP_ID = process.env.SUB_APPID

export const APP_CODE = 'amljpt'

export const COUNTRY_DOMAIN_MAP = {
  CN: process.env.DOMAIN_CN,
  VN: process.env.DOMAIN_VN,
}
